import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Button,
  Progress,
} from "@/components/ui";
import { FormProvider } from "react-hook-form";
import useQualityCheck from "./useQualityCheck";
import { CHECKLIST } from "./consts";
import { CircleCheck, CircleX } from "lucide-react";
import { Loader, PhotoSlider } from "@/components";
import { images } from "@/assets";
import { ChecksNoteDialog } from "./ChecksNoteDialog";

const QualityCheck = () => {
  const { form, openTabs, onAccordionChange, onAttachmentClick,
    isLoadingChecklist, isLoadingChecks,
    isPhotoSliderOpen, setIsPhotoSliderOpen, selectedPhotos, isAttachmentsLoading, isPlanApproved,
    onNotesClick, isNotesDialogOpen, setIsNotesDialogOpen
   } = useQualityCheck();

  return isLoadingChecklist || isLoadingChecks ? <Loader /> : (
    <>
      <FormProvider {...form}>
        <form>
          <div className="grid grid-cols-1 gap-[20px] pt-[20px] min-h-[400px] overflow-y-scroll px-5 pb-[100px] no-scrollbar">
            <Accordion
              type="multiple"
              value={openTabs}
              onValueChange={onAccordionChange}
            >
              {Object.values(form.watch(CHECKLIST))?.length == 0 ? <div className="flex items-center justify-center">
                <img src={images.no_data} className="h-[100px]" />
              </div> : Object.values(form.watch(CHECKLIST))?.map((data: any, index: number) => {
                const progress = Math.round(data?.items?.filter((check: any) => check?.status?.toLowerCase() == "passed")?.length / data?.items?.length * 100) || 0;
                return (
                  <AccordionItem
                    key={`safety-accordion-${index}`}
                    value={data?.accordionId}
                    className="px-5 rounded-lg mb-[20px] !border-1 border-gray-500"
                  >
                    <AccordionTrigger className="cursor-pointer text-brown-300">
                      {data?.title || ""}
                    </AccordionTrigger>
                    <AccordionContent>
                      <div className="grid grid-cols-1 gap-2 text-[14px]">
                        <div className="text-gray-500 flex flex-row gap-3 items-center">
                          <span>{data?.items?.length} checks required</span>
                          <div className="flex flex-row items-center gap-1">
                            <div className="h-2 w-2 bg-primary rounded-full" />{" "}
                            Complete all to finish
                          </div>
                        </div>
                        <div className="gap-2 flex flex-col">
                          <span className="text-black font-[600]">Progress</span>
                          <Progress
                            value={(progress || "0") as number}
                            className=" [&>div]:bg-primary bg-gray-200"
                          />
                        </div>
                        <div className="flex flex-col gap-2 text-brown-400 text-[500]">
                          {data?.items?.map((check: any, index: number) => (
                            <div className="flex flex-row gap-3 items-center justify-between">
                              <div className="flex flex-row gap-1 items-center">
                                <span>{index + 1}.</span>
                                <span>
                                  <u>{check?.name || ""}</u>
                                </span>
                              </div>
                                {isPlanApproved ? <div className="flex flex-row gap-2">
                                  <Button
                                    type="button"
                                    variant="link"
                                    className="text-primary underline px-0"
                                    onClick={() => onNotesClick(check)}
                                    disabled={isAttachmentsLoading}
                                  >
                                    Notes
                                  </Button>
                                  <Button
                                    type="button"
                                    variant="link"
                                    className="text-primary underline px-0"
                                    onClick={() => onAttachmentClick(check)}
                                    disabled={isAttachmentsLoading}
                                  >
                                    Attachment
                                  </Button>
                                </div> : <></>}
                              {check.status?.toLowerCase() == "passed" ? (
                                <CircleCheck className="stroke-green-600" />
                              ) : check.status?.toLowerCase() == "failed" ? (
                                <CircleX className="stroke-red-600" />
                              ) : (
                                <div className="h-6 w-6 border-2 border-dashed border-yellow-600 rounded-full px-2" />
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                )
              })}
            </Accordion>
          </div>
        </form>
      </FormProvider>
      <PhotoSlider
        isOpen={isPhotoSliderOpen}
        onClose={() => setIsPhotoSliderOpen(false)}
        photos={selectedPhotos}
        category="Quality Check Attachments"
        showActions={false}
      />
      <ChecksNoteDialog 
        open={isNotesDialogOpen}
        setOpen={setIsNotesDialogOpen}
      />
    </>
  );
};

export default QualityCheck;
